import React from "react";
import { Box } from "@mui/material";
import CustomUserChip from "./CustomUserChip";
import CustomGenericTittleIconDataChip from "./CustomGenericTittleIconDataChip";


/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * CustomGenericUserChip
 *
 * Generic component used to render a list of user chips with a title and icon.
 * It iterates over a list of items and displays a user chip for each one.
 *
 * @component
 *
 * @param {Array} list List of objects to be rendered as user chips.
 * @param {string} title Translation key used as the title label.
 * @param {React.ComponentType} Icon Icon component displayed in the title header.
 * @param {React.ComponentType} IconAvatar Icon component displayed as the avatar inside each user chip.
 * @param {function} getName Function that receives an item and returns the display name for the user chip.
 * @param {function} [keyExtractor] Optional function to generate a unique key for each item.Receives (item, index) as parameters.
 * @param {string} [className] Optional CSS class applied to the main title container.
 * @param {string} [classNameContainerList]  Optional CSS class applied to the main title container.
 * @returns {JSX.Element}
 * Rendered list of user chips with title and icons.
 */
const CustomGenericUserChip = ({ list, title, Icon, IconAvatar, getName,
                                   keyExtractor, className='',classNameContainerList=''}) => {

    return (
        <Box className={className}>
            <CustomGenericTittleIconDataChip Icon={Icon} title={title}/>
            <div className={classNameContainerList}>
                {list.map((item, index) => {
                    const name = getName(item).trim();
                    const key = keyExtractor ? keyExtractor(item, index) : index;

                    return (
                        <CustomUserChip
                            key={key}
                            name={name}
                            showAvatar
                            Icon={IconAvatar}
                        />
                    );
                })}
            </div>
        </Box>
    );
};

export default CustomGenericUserChip;
